import { Directive, Output, EventEmitter, ElementRef, Renderer2, Input } from '@angular/core';

@Directive({
  selector: '[confirm]'
})
export class ConfirmDirective {
  @Output('confirm') confirmed = new EventEmitter();
  constructor(private element: ElementRef, public renderer: Renderer2) { }
  @Input('message') message: string;
  @Input('ask') ask: boolean = true;
  ngOnInit() {
    var element = (<HTMLInputElement>this.element.nativeElement);
    this.renderer.listen(element, 'click', (event: MouseEvent) => {
      if (!this.ask || confirm(this.message || 'آیا از اجرای این دستور اطمینان دارید؟'))
        this.confirmed.emit();
    });
  }
}
